export default __webpack_public_path__ + "static/media/cp_geo_sn.12a64e97.svg";